export const authCardClass =
  "w-full max-w-md rounded-2xl bg-space-light/50 border border-white/10 p-8";

export const authLabelClass =
  "block text-body-sm font-medium text-gray-300 mb-1.5";

export const authInputClass =
  "w-full px-4 py-2.5 rounded-lg border border-white/20 bg-space/50 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-neon-green focus:border-transparent text-body-sm";

export const authInputErrorClass =
  "border-red-500/60 focus:ring-red-500/50";

export const authLinkClass =
  "font-medium text-neon-green hover:underline";
